/* this component takes the React Date Picker component from (http://react-day-picker.js.org) and
adds the date icon to the field. Since all the date pickers work the same way
it's stored in a custom component here */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import { formatDate } from 'react-day-picker/moment';
import { Glyphicon } from 'react-bootstrap';

const CalenderIcon = styled(Glyphicon)`
    margin-left: 20px;
    cursor: pointer;
`;

class RJRDatePicker extends Component {

    //we need to capture the change event of the text input component
    //the user needs to be able to type in "invalid" dates such as 19800000 since 
    //thats how they store dates that they don't know
    componentDidMount() {
        let textInput = this.datePicker.getInput();
        let compRef = this;
        textInput.addEventListener('change', function() {
            compRef.handleManualEventChange(this,compRef);
        });
    }

    setRefToDatePicker = (datePicker) => {
        this.datePicker = datePicker;
    }

    /* this is called when you click the calendar icon and handles 
    showing/hiding the date picker depending on its state. */
    openDatePicker = () => {
        if (this.datePicker.state.showOverlay === false) {
            this.datePicker.showDayPicker();
        } else {
            this.datePicker.hideDayPicker();
        }
    }

    //this function is called when you type in the text field. The only 
    //difference is that it DOES NOT format the date unlike the date picker component
    handleManualEventChange(e, compRef) {
        compRef.props.changeHandler({
            id: e.id,
            value: e.value
        });
    }

    //THIS function is called when you use the datepicker
    //the DayPickerInput library we used doesn't natively send the event object or any reference to this component
    //it only sends the value the user entered (so we can't use e.target.id) so we had to intercept it with our own 
    //change handler and send our own object
    dayChangeHandler = (e) => {    
        if (e) {
            this.props.changeHandler({
                id: this.props.id,
                value: formatDate(e, 'YYYYMMDD')
            });
        }
    }

    render() {
        return (
            <div>
                <DayPickerInput
                    format="YYYYMMDD"
                    formatDate={formatDate}
                    id={this.props.name}
                    dayPickerProps={{
                        todayButton: 'Today',
                    }}
                    inputProps={{
                        id: this.props.name
                    }}
                    placeholder="YYYYMMDD"
                    ref={this.setRefToDatePicker}
                    onDayChange={this.dayChangeHandler.bind(this)}
                    value={(this.props.formData.hasOwnProperty(this.props.name)) ? this.props.formData[this.props.name] : ''} 
                />
                <CalenderIcon onMouseDown={this.openDatePicker.bind(this)} glyph="calendar" />            
            </div>
        );
    }
}

RJRDatePicker.propTypes = {
    name: PropTypes.string
}

export default RJRDatePicker;


// WEBPACK FOOTER //
// ./src/components/shared/rjrDatePicker.js